import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '@stores/authStore';
import { getStaffFullName, getRoleDisplayName } from '@/types/staff';
import './Header.css';

export const Header = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuthStore();
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      // Check if it's a phone number or customer ID
      if (searchQuery.startsWith('+') || /^\d+$/.test(searchQuery)) {
        navigate(`/customers?search=${encodeURIComponent(searchQuery)}`);
      } else {
        // Search for case ID or name
        navigate(`/customers?search=${encodeURIComponent(searchQuery)}`);
      }
      setSearchQuery('');
    }
  };

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  if (!user) return null;

  return (
    <header className="header">
      <div className="header-left">
        <img 
          src="/src/assets/logo.gif" 
          alt="Mal Bank" 
          className="header-logo"
          onClick={() => navigate('/')}
        />
        <span className="header-title">Operations Dashboard</span>
      </div>

      <div className="header-center">
        <form onSubmit={handleSearch} className="global-search">
          <input
            type="search"
            placeholder="Search customer (phone, name, ID) or case..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="global-search-input"
          />
          <button type="submit" className="global-search-button">
            🔍
          </button>
        </form>
      </div>

      <div className="header-right">
        <button className="header-icon-button" title="Notifications">
          <span className="notification-icon">🔔</span>
          <span className="notification-badge">3</span>
        </button>

        <div className="header-user-menu">
          <button
            className="header-user-button"
            onClick={() => setShowUserMenu(!showUserMenu)}
          >
            <div className="user-avatar">
              {user.first_name[0]}{user.last_name[0]}
            </div>
            <div className="user-info">
              <span className="user-name">{getStaffFullName(user)}</span>
              <span className="user-role">{getRoleDisplayName(user.role)}</span>
            </div>
            <span className="dropdown-arrow">{showUserMenu ? '▲' : '▼'}</span>
          </button>

          {showUserMenu && (
            <div className="user-dropdown">
              <div className="user-dropdown-header">
                <p className="user-dropdown-name">{getStaffFullName(user)}</p>
                <p className="user-dropdown-email">{user.email}</p>
              </div>
              <div className="user-dropdown-divider"></div>
              <button
                className="user-dropdown-item"
                onClick={() => {
                  navigate('/settings/profile');
                  setShowUserMenu(false);
                }}
              >
                👤 Profile Settings
              </button>
              <button
                className="user-dropdown-item"
                onClick={() => {
                  navigate('/settings');
                  setShowUserMenu(false);
                }}
              >
                ⚙️ Settings
              </button>
              <div className="user-dropdown-divider"></div>
              <button
                className="user-dropdown-item user-dropdown-item-danger"
                onClick={handleLogout}
              >
                🚪 Logout
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Click outside to close dropdown */}
      {showUserMenu && (
        <div
          className="header-overlay"
          onClick={() => setShowUserMenu(false)}
        />
      )}
    </header>
  );
};

